import i18n from "@/plugins/i18n";

export default {
    // eslint-disable-next-line no-unused-vars
    install: (app, options) => {

        app.use(i18n)
    },
};
